<template>
    <div>
        <table style="width: 100%">
            <tr>
                <td>
                    <o-input v-model="filter" icon="filter" placeholder="Filter results" expanded clearable class="mb-4"></o-input>
                </td>
                <td class="has-text-right pt-1">
                    {{ $filters.AddCommas(companiesFiltered.length) }}
                    Companies
                </td>
            </tr>
        </table>

        <o-table :data="companiesFiltered" :paginated="companiesFiltered.length > perPage" :pagination-simple="true" :per-page="openColumns" :defaultSort="[sort, direction]" :sticky-header="true" hoverable>
            <template #empty>
                <h3 class="py-6">No companies match the filters</h3>
            </template>
            <o-table-column field="company" label="Company" v-slot="props" sortable>
                <router-link v-if="props.row.Id" target="_blank" :to="{ name: '_companyDetail', params: { Id: props.row.Id } }">
                    {{ props.row.company }}
                    <span v-if="props.row.IsKeyAccount"><i class="fal fa-key theme-key"></i></span>
                    <span v-if="hasActivePPA(props.row)"><i class="fal fa-file-alt theme-ppa"></i></span>
                </router-link>
                <span v-else>
                    {{ props.row.company }}
                    <span v-if="props.row.IsKeyAccount"><i class="fal fa-key theme-key"></i></span>
                    <span v-if="hasActivePPA(props.row)"><i class="fal fa-file-alt theme-ppa"></i></span>
                </span>
            </o-table-column>
            <o-table-column field="parent" label="Subsidiary of" v-slot="props" sortable>
                <router-link v-if="props.row.parentId" target="_blank" :to="{ name: '_companyDetail', params: { Id: props.row.parentId } }">
                    {{ props.row.parent }}
                    <span v-if="props.row.parentIsKeyAccount"><i class="fal fa-key theme-key"></i></span>
                    <span v-if="hasParentActivePPA(props.row)"><i class="fal fa-file-alt theme-ppa"></i></span>
                </router-link>
                <span v-else>
                    {{ props.row.parent }}
                    <span v-if="props.row.parentIsKeyAccount"><i class="fal fa-key theme-key"></i></span>
                    <span v-if="hasParentActivePPA(props.row)"><i class="fal fa-file-alt theme-ppa"></i></span>
                </span>
            </o-table-column>
            <o-table-column field="owner" label="Owner" class="thin" v-slot="props" sortable>
                {{ props.row.owner }}
            </o-table-column>
            <o-table-column field="status" label="Status" v-slot="props" sortable>
                {{ props.row.status }}
            </o-table-column>
            <o-table-column field="offLimitsDate" label="Off limits date" sortable v-slot="props">
                <span v-if="props.row.offLimitsDate">
                    {{ $filters.OffLimitsDate(props.row.status, props.row.offLimitsDate) }}
                </span>
            </o-table-column>
            <o-table-column field="inveniasId" label="Invenias" v-slot="props">
                <span v-if="!props.row.inveniasId">
                    <!--<o-button variant="default" icon-left="link" size="small" @click="LinkInvenias(props.row)">Link to Invenias</o-button>-->
                </span>
                <a :href="$filters.InveniasUrl(props.row.inveniasId)" target="_blank" v-else>Visit <o-icon icon="external-link"></o-icon></a>
            </o-table-column>
            <o-table-column field="zoominfoId" label="ZoomInfo" v-slot="props">
                <span v-if="!props.row.zoominfoId">

                </span>
                <a :href="'https://www.zoominfo.com/c/' + $filters.KebabCase(props.row.company) + '/' + props.row.zoominfoId" target="_blank" v-else>Visit <o-icon icon="external-link"></o-icon></a>
            </o-table-column>
        </o-table>
    </div>
</template>
<script>
    import { ref, inject, watch, computed, onMounted, getCurrentInstance } from "vue";
    import { useRouter } from "vue-router";
    import linkCompanyModal from "@/components/modals/invenias/link-company.vue";

    export default {
        props: {
            data: {
                type: Array,
                default: () => {
                    return [];
                }
            },
            sort: {
                type: String,
                default: "company"
            },
            direction: {
                type: String,
                default: "asc"
            },
            perPage: {
                type: Number,
                default: 50
            },
            infiniteScroll: {
                type: Boolean,
                default: false
            }
        },
        setup(props, context) {
            const $router = useRouter();
            const oruga = inject("oruga");
            const moment = inject("$moment");

            const companiesLocal = computed(() => props.data);
            const filter = ref("");

            const global = getCurrentInstance()?.appContext.config.globalProperties;

            const hasActivePPA = (row) => row?.hasActivePPA || row?.HasActivePPA || row?.hasActivePpa;
            const hasParentActivePPA = (row) => row?.parentHasActivePPA || row?.ParentHasActivePPA;

            const companiesFiltered = computed(() => {
                if (!filter.value || filter.value == "") {
                    return companiesLocal.value;
                }

                const filterString = filter.value.toLowerCase();

                return companiesLocal.value.filter((x) => {
                    if (
                        x.company?.toLowerCase().indexOf(filterString) >= 0 ||
                        x.parent?.toLowerCase().indexOf(filterString) >= 0 ||
                        x.owner?.toLowerCase().indexOf(filterString) >= 0 ||
                        x.status?.toLowerCase().indexOf(filterString) >= 0
                    )
                        return true;
                });
            });

            const openColumns = ref(props.perPage);

            const RowClicked = (row, index) => {
                if (index == 0) return;
                const route = $router.resolve({ name: "_companyDetail", params: { Id: row.Id } });
                window.open(route.href);
            };

            const LinkInvenias = (row) => {
                const company = { ID: row.Id, Name: row.company };
                oruga.modal.open({
                    parent: getCurrentInstance(),
                    component: linkCompanyModal,
                    trapFocus: true,
                    props: {
                        company: company
                    },
                    events: {
                        close: (result) => {
                            if (result && result.linked) {
                                row.inveniasId = result.inveniasId;
                            }
                        }
                    }
                });
            };

            if (props.infiniteScroll) {
                const main = document.getElementById("main");
                main.onscroll = function (event) {
                    const element = event.target;

                    if (element.scrollHeight - element.scrollTop <= element.clientHeight + 2) {
                        openColumns.value += props.perPage;
                    }
                };
            }

            return { moment, filter, companiesFiltered, openColumns, RowClicked, LinkInvenias, hasActivePPA, hasParentActivePPA };
        }
    };
</script>

